import * as PropTypes from "prop-types";
import {field} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";

/**
 * Field pro výběr nebo zadání názvu objednávky.
 */
class NakladoveStrediskoField extends Component {

    static propTypes = {
        nakladovaStrediska: PropTypes.array.isRequired, // seznam nákladových středisek
    };

    handleFilterSuggestions = (value) => {
        const {nakladovaStrediska} = this.props;
        const inputValue = value ? value.toLowerCase().trim() : "";
        return nakladovaStrediska.filter(item => item.nazevStredisko.toLowerCase().indexOf(inputValue) !== -1);
    };

    render() {
        const {nakladovaStrediska, ...other} = this.props;

        return <field.SimpleSuggest
            dropdown={true}
            renderSuggestion={(i, active, getItemValue) => i ? i.nazevStredisko : ""}
            getItemValue={i => i ? i.nazevStredisko : ""}
            filterSuggestions={this.handleFilterSuggestions}
            items={nakladovaStrediska}
            {...other}
        />
    }
}

export default NakladoveStrediskoField;
